import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@gjl/site-kit/image'
import { WINNERS_2026, type Winner } from '../data/winners-2026'

export default function WinnersPage() {
  useEffect(() => {
    document.title = '2026 Winners | Sierra Canyon Photo Competition'
  }, [])

  const [first, ...runnersUp] = WINNERS_2026

  return (
    <div className="bg-background min-h-[100dvh] px-4 py-4 md:py-6">
      <main className="mx-auto max-w-5xl">
        <header className="mb-4 text-center md:mb-6">
          <Link to="/" className="inline-block rounded-sm">
            <Image
              priority
              src="/brand/Horse_SolidBlue.png"
              alt="Back to competition home"
              className="mx-auto mb-2 h-9 w-auto drop-shadow-[0_0_6px_rgba(255,255,255,0.5)] md:h-11"
            />
          </Link>
          <p className="text-accent text-sm font-semibold">Sierra Canyon Photo Competition</p>
          <h1 className="text-foreground font-display text-3xl font-bold tracking-tight md:text-5xl">2026 Winners</h1>
        </header>

        {first ? (
          <ol className="space-y-12 md:space-y-16">
            <li>
              <WinnerCard winner={first} priority />
            </li>
            {runnersUp.length > 0 && (
              <li>
                <ol className="grid gap-12 md:grid-cols-2 md:gap-8">
                  {runnersUp.map((winner) => (
                    <li key={winner.place}>
                      <WinnerCard winner={winner} />
                    </li>
                  ))}
                </ol>
              </li>
            )}
          </ol>
        ) : (
          <p className="text-foreground-muted text-center">Winners will be posted soon.</p>
        )}
      </main>
    </div>
  )
}

function WinnerCard({ winner, priority = false }: { winner: Winner; priority?: boolean }) {
  return (
    <figure>
      {/* Never crop an entry: the frame follows the photo's own shape. 18rem leaves room for the header and caption, keeping 1st place above the fold. */}
      <Image
        priority={priority}
        src={winner.photo}
        alt={`${winner.title} by ${winner.name}`}
        className={`border-border mx-auto w-auto max-w-full rounded-lg border ${priority ? 'max-h-[calc(100dvh-18rem)]' : 'max-h-[80vh]'}`}
      />
      <figcaption className="mt-4 text-center">
        <p className="text-accent text-sm font-semibold md:text-base">{winner.place}</p>
        <h2 className="text-foreground font-display mt-1 text-2xl font-bold md:text-3xl">{winner.title}</h2>
        <p className="text-foreground-muted mt-1 text-base">{winner.name}</p>
      </figcaption>
    </figure>
  )
}
